/* Same public storefront feed as VESSEL US. No customer data or credentials. */
(() => {
  const storeKey = 'AIgQTigTRNuJF5Z1I8RoKs2JvyxqShUcx6AfVWLb';
  const productsUrl = document.currentScript?.dataset.productsUrl;
  const responses = new Map();
  const observed = new WeakMap();
  const queue = [];
  let catalog;
  let active = 0;

  function pump() {
    while (active < 4 && queue.length) {
      const { id, resolve } = queue.shift();
      active += 1;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      fetch(`https://api-cdn.yotpo.com/v3/storefront/store/${storeKey}/product/${id}/ratings`, {
        credentials: 'omit', signal: controller.signal
      })
        .then(response => response.ok ? response.json() : null)
        .then(data => {
          const count = data?.bottomline?.totalReviews;
          const score = data?.bottomline?.averageScore;
          resolve(Number.isInteger(count) && count >= 0 && Number.isFinite(score) && score >= 0 && score <= 5
            ? { count, score: Number(score.toFixed(1)) } : null);
        })
        .catch(() => resolve(null))
        .finally(() => { clearTimeout(timeout); active -= 1; pump(); });
    }
  }

  function display(element, { count, score }) {
    element.hidden = count === 0;
    element.querySelector('[data-us-rating-score]').textContent = score;
    const countNode = element.querySelector('[data-us-rating-count]');
    if (countNode) countNode.textContent = (count === 1 ? element.dataset.countOne : element.dataset.countMany).replace('__count__', count);
    const label = element.dataset.sourceLabel.replace('__count__', count);
    element.title = label;
    element.setAttribute('aria-label', label);
    element.querySelector('.rating__stars').setAttribute('aria-label', element.dataset.scoreLabel.replace('__score__', score));
  }

  function refresh(element) {
    const id = element.dataset.vesselUsRating;
    if (!/^\d+$/.test(id) || observed.get(element) === id) return;
    observed.set(element, id);
    if (!responses.has(id)) {
      responses.set(id, new Promise(resolve => queue.push({ id, resolve })));
      pump();
    }
    responses.get(id).then(value => {
      // Keep the verified snapshot on failure. Ignore responses for a previous selection.
      if (!value || !element.isConnected || element.dataset.vesselUsRating !== id) return;
      display(element, value);
      element.dataset.usRatingStatus = 'live';
    });
  }

  function selectSource(element, source) {
    observed.delete(element);
    element.dataset.usRatingStatus = 'snapshot';
    element.dataset.vesselUsRating = source?.us_id || '';
    if (!source) { element.hidden = true; return; }
    element.href = source.us_reviews_url || source.us_url;
    display(element, { count: source.review_count, score: Number(source.rating) });
    refresh(element);
  }

  function scan(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root !== document) return;
    if (root.matches?.('[data-vessel-us-rating]')) refresh(root);
    root.querySelectorAll('[data-vessel-us-rating]').forEach(refresh);
  }
  scan(document);
  new MutationObserver(records => {
    for (const record of records) record.addedNodes.forEach(scan);
  }).observe(document.body, { childList: true, subtree: true });

  // Some Thailand products combine sizes/colors that the US sells on separate pages.
  document.addEventListener('variant:change', event => {
    const variantId = event.detail?.variant?.id;
    document.querySelectorAll('[data-vessel-us-variants]').forEach(element => {
      // A form input named "id" shadows HTMLFormElement.id; read the attribute directly.
      if (element.dataset.productForm !== event.target.getAttribute('id')) return;
      let variants;
      try { variants = JSON.parse(element.dataset.vesselUsVariants || '{}'); } catch { return; }
      if (!Object.keys(variants).length) return;
      selectSource(element, variants[variantId]);
    });
  });

  // Impact's native card radios use the theme's matching variant without emitting variant:change.
  document.addEventListener('change', async event => {
    const input = event.target.closest?.('product-card input[type="radio"]');
    const card = input?.closest('product-card');
    const element = card?.querySelector('[data-vessel-us-variants]');
    if (!element || typeof card._getMatchingVariant !== 'function') return;
    let variants;
    try { variants = JSON.parse(element.dataset.vesselUsVariants || '{}'); } catch { return; }
    if (!Object.keys(variants).length) return;
    selectSource(element, null);
    try {
      const variant = await card._getMatchingVariant(input);
      if (input.checked && element.isConnected) selectSource(element, variants[variant?.id]);
    } catch { /* Keep the rating hidden when the selected source cannot be resolved. */ }
  });

  // Product cards swap between separate Thailand products without navigating.
  document.addEventListener('click', event => {
    const swatch = event.target.closest?.('.cw-colour-circle');
    const card = swatch?.closest('product-card');
    const element = card?.querySelector('[data-vessel-us-rating]');
    if (!element || !productsUrl) return;
    const handle = new URL(swatch.dataset.cwUrl, location.origin).pathname.split('/products/')[1];
    if (!handle) return;
    element.dataset.vesselThHandle = handle;
    // Hide the old product's rating while the new source is being resolved.
    selectSource(element, null);
    catalog ||= fetch(productsUrl, { credentials: 'omit' }).then(response => response.ok ? response.json() : null).catch(() => null);
    catalog.then(data => {
      if (!element.isConnected || element.dataset.vesselThHandle !== handle) return;
      const product = data?.products?.[handle];
      const source = product?.variants?.[swatch.dataset.cwVariant] || product;
      selectSource(element, source);
    });
  }, true);
})();
